import { Schema } from "effect";
import { makeSealedValue } from "@open-revenue/utils/secrets";
export const PublishableTestKey = Schema.TemplateLiteral(Schema.Literal("pk_test_"), Schema.String).pipe(Schema.annotations({
    identifier: "StripePublishableTestKey",
    description: "A Stripe publishable test key.",
    examples: [
        "pk_test_1234567890",
        "pk_test_abcdefghij"
    ],
    externalReferenceUrl: "https://stripe.com/docs/api/keys/object#key_object-id"
}), Schema.brand("StripePublishableTestKey"));
export const PublishableTestKeySealed = makeSealedValue(PublishableTestKey);
export const SecretTestKey = Schema.TemplateLiteral(Schema.Union(Schema.Literal("sk_test_"), Schema.Literal("rk_test_"), Schema.String), Schema.String).pipe(Schema.annotations({
    identifier: "StripeSecretTestKey",
    description: "A Stripe secret test key.",
    examples: [
        "sk_test_1234567890",
        "sk_test_abcdefghij"
    ],
    externalReferenceUrl: "https://stripe.com/docs/api/keys/object#key_object-id"
}), Schema.brand("StripeSecretTestKey"));
export const SecretTestKeySealed = makeSealedValue(SecretTestKey);
export const PublishableLiveKey = Schema.TemplateLiteral(Schema.Literal("pk_live_"), Schema.String).pipe(Schema.annotations({
    identifier: "StripePublishableLiveKey",
    description: "A Stripe publishable live key.",
    examples: [
        "pk_live_1234567890",
        "pk_live_abcdefghij"
    ],
    externalReferenceUrl: "https://stripe.com/docs/api/keys/object#key_object-id"
}), Schema.brand("StripePublishableLiveKey"));
export const PublishableLiveKeySealed = makeSealedValue(PublishableLiveKey);
export const SecretLiveKey = Schema.TemplateLiteral(Schema.Union(Schema.Literal("sk_live_"), Schema.Literal("rk_live_"), Schema.String), Schema.String).pipe(Schema.annotations({
    identifier: "StripeSecretLiveKey",
    description: "A Stripe secret live key.",
    examples: [
        "sk_live_1234567890",
        "sk_live_abcdefghij"
    ],
    externalReferenceUrl: "https://stripe.com/docs/api/keys/object#key_object-id"
}), Schema.brand("StripeSecretLiveKey"));
export const SecretLiveKeySealed = makeSealedValue(SecretLiveKey);
export const SecretKey = Schema.Union(SecretTestKey, SecretLiveKey);
export const SecretKeySealed = makeSealedValue(SecretKey);
export const PublishableKey = Schema.Union(PublishableTestKey, PublishableLiveKey);
export const PublishableKeySealed = makeSealedValue(PublishableKey);
export const Keys = Schema.Union(PublishableKey, SecretKey);
export const KeysSealed = makeSealedValue(Keys);
